export { default } from './Publicitat';
